import 'choerodon-ui/lib/style/index.less';
import './index.less';
// style dependencies
import '../../trigger-field/style';
import '../../spin/style';
import '../../text-field/style';
import 'choerodon-ui/lib/menu/style';
import 'choerodon-ui/lib/checkbox/style';
import 'choerodon-ui/lib/tag/style';
